export enum Roles {
  Guest = "guest",
  Admin = "admin",
  Manager = "manager",
  Employee = "employee"
}
